export function capitalizeFirstLetter<T extends string>(
  input: T
): Capitalize<T> {
  if (!input) {
    return input as Capitalize<T>;
  }
  return (input.charAt(0).toUpperCase() + input.slice(1)) as Capitalize<T>;
}

export function capitalizeWords(input: string): string {
  if (!input) {
    return input;
  }
  return input
    .split(" ")
    .map((word) => capitalizeFirstLetter(word))
    .join(" ");
}

export function capitalizeWordAtPosition(
  input: string,
  cursorPosition: number
): string {
  if (!input) {
    return input;
  }

  const words = input.split(" ");
  const capitalizedWords = words.map((word, index) => {
    if (word.length === 0) return word;

    // Find the position of this word in the original string
    const wordStart =
      words.slice(0, index).join(" ").length + (index > 0 ? 1 : 0);

    // Only capitalize if we're at the first letter of this word
    if (cursorPosition === wordStart + 1 && word.length === 1) {
      return capitalizeFirstLetter(word);
    }
    return word;
  });

  return capitalizedWords.join(" ");
}

export function removeNonAlphabetic(input: string) {
  if (!input) {
    return input;
  }
  return input.replace(/[^a-zA-Z]/g, "");
}

export function removeNonNumeric(input: string) {
  if (!input) {
    return input;
  }
  return input.replace(/\D/g, "");
}
